const PDPDLogosSwiper = new Swiper(".pdp-logos-marquee__slider", {
  slidesPerView: 5,
  spaceBetween: 80,
  loop: true,

  navigation: {
    nextEl: ".pdp-logos-marquee__arrow--next",
    prevEl: ".pdp-logos-marquee__arrow--prev",
  },

  breakpoints: {
    0: {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
      loop: true
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 40,
      loop: true
    },
    1440: {
      slidesPerView: 5,
      spaceBetween: 80,
      loop: false
    }
  }
});